<template>
    <div class="chatbot-plans">
        <div class="d-flex">
            <div class="side-menubar-wrapper">
                <SideMenuBar />
            </div>
            <div class="body">
                <div class="title">{{ $t('message.planManagement') }}</div>
                <div class="content">
                    <div class="plan-statistic">
                        <div class="statistic-item">
                            <a-progress type="circle" :percent="getChatbotSessionStatus()" :strokeWidth="10" />
                            <div class="statistic-content">
                                <div class="statistic-title">{{ $t('message.usedSessionCount') }}</div>
                                <div class="statistic-value">{{ conversationStatistics.chatbotUsage }}</div>
                            </div>
                        </div>
                        <div class="statistic-item">
                            <div class="statistic-content">
                                <div class="statistic-title">{{ $t('message.maxSessionCount') }}</div>
                                <div class="statistic-value">{{ features.totalSessionCount }}</div>
                            </div>
                        </div>
                        <div class="statistic-item">
                            <div class="statistic-content">
                                <div class="statistic-title">{{ $t('message.leftSessionCount') }}</div>
                                <div class="statistic-value">
                                    {{ features.totalSessionCount - conversationStatistics.chatbotUsage }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div style="width: 100%">
                    <div style="font-size: 18px; font-weight: bold; margin-top: 20px; margin-bottom: 10px">
                        Extra Packages
                    </div>
                    <div style="width: 100%">
                        <a-table :columns="columns" :data-source="extraSubscriptions" :pagination="false">
                            <span slot="startDate" slot-scope="startDate"> {{ formatDate(startDate) }} </span>
                            <span slot="endDate" slot-scope="endDate"> {{ formatDate(endDate) }} </span>
                            <span slot="expired" slot-scope="endDate">
                                {{ isExpired(endDate) ? "Expired" : "In Use" }}
                            </span>
                        </a-table>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import SideMenuBar from "../../SideMenuBar";
import { mapActions, mapMutations, mapState } from "vuex";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";

export default {
    name: "UserSegments",
    components: { SideMenuBar },
    data() {
        return {
            columns: [
                {
                    title: "Start Date",
                    dataIndex: "startDate",
                    scopedSlots: { customRender: "startDate" },
                },
                {
                    title: "End Date",
                    dataIndex: "endDate",
                    scopedSlots: { customRender: "endDate" },
                },
                {
                    title: "Session Count",
                    dataIndex: "sessionCount",
                    scopedSlots: { customRender: "sessionCount" },
                },
                {
                    title: "",
                    dataIndex: "endDate",
                    scopedSlots: { customRender: "expired" },
                },
            ],
            cancels: [],
        };
    },
    computed: {
        ...mapState({
            features: (state) => state.site.features,
            conversationStatistics: (state) =>
                state.site.conversationStatistics.reduce(
                    (acc, usage) => {
                        acc.chatbotUsage += usage.chatbotUsage;
                        acc.whatsappCounter += usage.whatsappCounter;
                        acc.instagramCounter += usage.instagramCounter;
                        acc.telegramCounter += usage.telegramCounter;
                        acc.webCounter += usage.webCounter;
                        acc.whatsappBusinessCounter += usage.whatsappBusinessCounter;
                        return acc;
                    },
                    {
                        chatbotUsage: 0,
                        whatsappCounter: 0,
                        instagramCounter: 0,
                        telegramCounter: 0,
                        webCounter: 0,
                        whatsappBusinessCounter: 0,
                    }
                ),
        }),
    },
    methods: {
        ...mapMutations({
            SET_LARGE_HEADER: "app/SET_LARGE_HEADER",
        }),
        ...mapActions({
            getSiteFeatures: "site/getSiteFeatures",
            getConversationStatistics: "site/getConversationStatistics",
        }),
        getChatbotSessionStatus() {
            const leftPercentTile =
                (100 / this.features.totalSessionCount) *
                (this.features.totalSessionCount - this.conversationStatistics.chatbotUsage);
            return Math.max(0, (100 - leftPercentTile).toFixed(1));
        },
        formatDate(date) {
            return date && this.$moment(date).format("YYYY/MM/DD HH:mm");
        },
        isExpired(endDate) {
            return this.$moment(endDate).diff(this.$moment()) < 0;
        },
    },
    mounted() {
        this.SET_LARGE_HEADER(false);
        this.getSiteFeatures();
    },
    beforeDestroy() {
        this.SET_LARGE_HEADER(true);
    },
    beforeMount() {},
};
</script>

<style lang="scss">
.chatbot-plans {
    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        width: max-content !important;
    }
    .body {
        padding: 40px;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 10px;
        width: 100%;
        .title {
            font-weight: bold;
            font-size: 20px;
        }
        .content {
            width: calc(100% - 60px);
            .plan-statistic {
                grid-template-columns: calc(100% / 3) calc(100% / 3) calc(100% / 3);
                display: grid;
                align-items: center;
                column-gap: 20px;
                .statistic-item {
                    background-color: white;
                    border: 1px;
                    padding: 10px 15px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    width: 100%;
                    .statistic-content {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }
                    .ant-progress-inner {
                        width: 40px !important;
                        height: 40px !important;
                        .ant-progress-circle-path {
                            stroke: #ec4b1d !important;
                        }
                    }
                    .statistic-content {
                        .statistic-title {
                            font-weight: bold;
                            font-size: 20px;
                        }
                        .statistic-value {
                            font-weight: bold;
                        }
                    }

                    .ant-progress-text {
                        font-size: 10px;
                        font-weight: bold;
                    }
                }
            }
        }
        .kanban-task-table {
            background-color: #eef0f8;
            padding: 20px;
        }

        .ant-table-tbody {
            background: #fff;
        }
        .ant-table-thead > tr > th {
            background: #fff;
        }
        .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
            background-color: #ffded5;
        }
    }
}
</style>
